/* istanbul ignore file */
const exportTheme = (theme) => {
  const dataStr = JSON.stringify(theme);
  const dataUri = `data:application/json;charset=utf-8,${encodeURIComponent(dataStr)}`;

  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', 'theme.json'); // note: no IE support
  document.body.appendChild(linkElement); // required for firefox
  linkElement.click();
  linkElement.remove();
};

export default exportTheme;
